import React, { useEffect, useState } from "react";
import { EventData } from "../../interface/event.interface";
import { useUserRole } from "../../hooks/useUserRole.hook";
import { storageConst } from "../../utils/constants";
import { useNavigate } from "react-router";
import Button from "../../components/Button";
import { Search } from "lucide-react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../lib/firebase";
import EventCard from "../../components/eventCard";
import SkeletonCard from "../../components/skeltonCard";

const FavoriteEvents = () => {
  const [filter, setFilter] = useState<string>("all");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [isLogin, setIsLogin] = useState(false);
  const [events, setEvents] = useState<EventData[]>([]);
  const [loading, setLoading] = useState(false);
  const userRole = useUserRole(storageConst.APPTOKEN);
  const userId = localStorage.getItem(storageConst.APPTOKEN);
  const navigate = useNavigate();
  useEffect(() => {
    setIsLogin(localStorage.getItem(storageConst.APPTOKEN) ? true : false);
    const fetchEvents = async () => {
      try {
        setLoading(true);
        const eventsCollection = collection(db, "products");
        const favoriteQuery = query(
          eventsCollection,
          where("favrioute", "array-contains", userId)
        );
        const eventSnapshot = await getDocs(favoriteQuery);
        const eventList = eventSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...(doc.data() as Omit<EventData, "id">),
        }));
        console.log(eventList);

        setEvents(eventList);
      } catch (error) {
        console.error("Error fetching events: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, [userId]);
  const filteredEvents = events.filter((event: EventData) => {
    const eventName = event.eventname || "";
    const matchesSearch = eventName
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesFilter =
      filter === "all" ||
      (filter === "publish" && event.publish) ||
      (filter === "unpublish" && !event.publish);
    return matchesSearch && matchesFilter;
  });

  const handleLoginRedirect = () => {
    navigate("/signin");
  };
  return (
    <div>
      <div>
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-center mb-8 space-y-4 sm:space-y-0">
          <div className="flex items-center w-full sm:w-auto">
            <div className="relative flex-1 sm:flex-none">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search by name"
                // className="pl-10 pr-4 py-2 w-full sm:w-64 bg-background border-gray-700 rounded-full focus:ring-2 focus:ring-primary transition-all"
                className="w-full pl-9 pr-2 focus-visible:outline-none h-[50px] bg-bgCard border rounded-full"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          {/* Dropdown and Add Button */}

          <div className="flex items-center space-x-4">
            {!isLogin && (
              <Button
                label="Sign In"
                onClick={handleLoginRedirect}
                className="rounded-full"
              ></Button>
            )}
            {userRole === "ADMIN" && (
              <select
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                className="bg-bgCard border-bg rounded-full py-2 px-2 focus:ring-2 focus:ring-primary"
              >
                <option value="all">All</option>
                <option value="publish">Published</option>
                <option value="unpublish">Unpublished</option>
              </select>
            )}
          </div>
        </div>

        {/* Events List */}

        <div>
          {loading ? (
            // Show skeletons during loading
            <div className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">
              {Array.from({ length: 8 }).map((_, index) => (
                <SkeletonCard key={index} />
              ))}
            </div>
          ) : filteredEvents.length > 0 ? (
            // Show actual events after loading
            <div className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">
              {filteredEvents.map((event, index) => (
                <EventCard item={event} key={index} />
              ))}
            </div>
          ) : (
            <p className="text-gray-500 flex justify-center">
              No events found.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FavoriteEvents;
